const ServiceNotAvailable = () => {
  return (
    <div style={{ paddingLeft: "10px" }}>
      <h4>503 Service Unavailable</h4>
    </div>
  );
};

export default ServiceNotAvailable;
